import axios from "axios";
import constants from "@/utils/constants.js";
import store from "@/store";

const Api = axios.create({ baseURL: constants.BASE_API_URL });

export default {
  hotspots: {
    async getHotspots() {
      return Api.get("hotspots", {
        params: { language: store.getters.getLocale }
      });
    },
    async getHotspot(id) {
      return Api.get(`hotspots/${id}`, {
        params: { language: store.getters.getLocale }
      });
    }
  },
  themes: {
    async getThemes() {
      return Api.get("themes", {
        params: {
          language: store.getters.getLocale,
          app_id: store.getters.getAppId
        }
      });
    }
  },
  routes: {
    async getRoutes() {
      return Api.get("routes", {
        params: {
          language: store.getters.getLocale,
          app_id: store.getters.getAppId
        }
      });
    }
  },
  articles: {
    async getArticle(article_id) {
      return Api.get(`articles/${article_id}`, {
        params: { language: store.getters.getLocale }
      });
    }
  },
  featuredArticles: {
    async getFeaturedArticles() {
      return Api.get(`featured-articles`, {
        params: {
          language: store.getters.getLocale,
          app_id: store.getters.getAppId
        }
      });
    }
  },
  search: {
    async getSearch(term) {
      return Api.get(`search?query=${term}`, {
        params: { language: store.getters.getLocale }
      });
    }
  },
  comments: {
    async addComment(payload) {
      return Api.post(
        "comments",
        {
          ...payload
        },
        { headers: { "x-csrf-token": "anything" } }
      );
    }
  }
};
